import React, { useState } from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { products } from '../mockData';

const Products = () => {
  const [selectedProduct, setSelectedProduct] = useState(products[0].id);

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="stars-container">
            {[...Array(30)].map((_, i) => (
              <div
                key={i}
                className="star"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 3}s`
                }}
              />
            ))}
          </div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-light mb-6 tracking-tight">
            Our Products
          </h1>
          <p className="text-xl text-white/60 leading-relaxed">
            Innovative solutions designed to empower creators and streamline workflows
          </p>
        </div>
      </section>

      {/* Products Showcase */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {products.map((product, index) => (
            <div
              key={product.id}
              id={product.id}
              className={`mb-32 ${index !== 0 ? 'border-t border-white/10 pt-32' : ''}`}
            >
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                {/* Product Info */}
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  {product.logo && (
                    <img 
                      src={product.logo} 
                      alt={product.name} 
                      className="h-20 mb-6 opacity-90"
                    />
                  )}
                  {!product.logo && (
                    <h2 className="text-4xl md:text-5xl font-light mb-4">{product.name}</h2>
                  )}
                  
                  <p className="text-white/50 text-lg mb-6">{product.tagline}</p>
                  
                  <p className="text-white/70 text-lg leading-relaxed mb-8">
                    {product.description}
                  </p>

                  <div className="mb-8">
                    <h3 className="text-xl font-medium mb-4">Key Features</h3>
                    <ul className="space-y-3">
                      {product.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start space-x-3">
                          <div className="flex-shrink-0 w-5 h-5 rounded-full bg-white/10 flex items-center justify-center mt-0.5">
                            <Check size={12} className="text-white" />
                          </div>
                          <span className="text-white/70">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-gradient-to-br from-white/5 to-white/[0.02] rounded-2xl p-6 border border-white/10 mb-8">
                    <p className="text-white/80 leading-relaxed italic">
                      "{product.benefits}"
                    </p>
                  </div>

                  <div className="text-white/50 text-sm">
                    <span className="font-medium">Built for:</span> {product.audience}
                  </div>
                </div>

                {/* Product Visual */}
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  {product.logo ? (
                    <img 
                      src={product.logo} 
                      alt={product.name} 
                      className="w-full max-w-md mx-auto"
                    />
                  ) : (
                    <div className="text-8xl font-light text-white/30">
                      {product.name.charAt(0)}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 border-t border-white/10">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-light mb-6">
            Interested in our products?
          </h2>
          <p className="text-white/60 text-lg mb-12">
            Get in touch to learn more about how NRFSTR products can help you
          </p>
          <a
            href="/contact"
            className="inline-flex items-center px-8 py-4 bg-white text-black rounded-full font-medium hover:bg-white/90 transition-all duration-300 group"
          >
            <span>Contact Us</span>
            <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </section>
    </div>
  );
};

export default Products;
